export default{
    icon: "el-icon-price-tag",
    title: "商品列表瀑布",
    name: "goodWaterfall",
    timestamp: "1723002329011023",
    setUp: {
        tabVal: 0
    },
    tabConfig: {
        title: "选择模板",
        tabVal: 0,
        type: 0,
        list: [
            {
                name: "自动选择",
                icon: "el-icon-setting"
            },
            {
                name: "手动选择",
                icon: "el-icon-thumb"
            }
        ]
    },
    titleShow: {
        title: "是否显示名称",
        val: true
    },
    opriceShow: {
        title: "是否显示原价",
        val: true
    },
    priceShow: {
        title: "是否显示价格",
        val: true
    },
    couponShow: {
        title: "是否显示优惠券",
        val: true
    },
    searchShow: {
        title: "是否显筛选器",
        val: true
    },
    selectConfig: {
        title: "商品分类",
        val: "",
    },
    goodsSort: {
        title: "商品排序",
        name: "goodsSort",
        type: 0,
        list: [
            {
                val: "综合",
                icon: "iconComm_whole"
            },
            {
                val: "销量",
                icon: "iconComm_number"
            },
            {
                val: "价格",
                icon: "iconComm_Price"
            }
        ]
    },
    numConfig: {
        title: "商品数量",
        val: 6
    },
    themeColor: {
        title: "背景颜色",
        name: "themeColor",
        default: [
            {
                item: "#fff"
            }
        ],
        color: [
            {
                item: "#fff"
            }
        ]
    },
    fontColor: {
        title: "价格颜色",
        name: "fontColor",
        default: [
            {
                item: "#e93323"
            }
        ],
        color: [
            {
                item: "#e93323"
            }
        ]
    },
    labelColor: {
        title: "活动标签",
        name: "labelColor",
        default: [
            {
                item: "#e93323"
            }
        ],
        color: [
            {
                item: "#e93323"
            }
        ]
    },
    itemStyle: {
        title: "显示类型",
        name: "itemSstyle",
        type: 0,
        list: [
            {
                val: "两列",
                icon: "el-icon-menu"
            }
        ]
    },
    bgStyle: {
        title: '背景样式',
        name: 'bgStyle',
        type: 1,
        list: [
            {
                val: '直角',
                icon: 'el-icon-edit-outline'
            },
            {
                val: '圆角',
                icon: 'el-icon-c-scale-to-original'
            }
        ]
    },
    bgColorImg: {
        title: '背景设置',
        name: 'bgColorImg',
        url: '',
        default: [
            {
                item: '#eeeeee'
            }
        ],
        color: [
            {
                item: '#eeeeee'
            }
        ]
    },
    txtBgColor: {
        title: '背景设置',
        name: 'txtBgColor',
        default: [
            {
                item: '#fff'
            }
        ],
        color: [
            {
                item: '#fff'
            }
        ]
    },
    conStyle: {
        title: "内容样式",
        name: "conStyle",
        type: 1,
        list: [
            {
                val: '直角',
                icon: 'el-icon-edit-outline'
            },
            {
                val: '圆角',
                icon: 'el-icon-c-scale-to-original'
            }
        ]
    },
    prConfig: {
        title: "背景边距",
        val: 0,
        min: 0
    },
    productList: {
        title: "商品列表",
        list: []
    },
    goodsList: {
        max: 20,
        list: [
            {
                id: "",
                name: "小米智能保温杯Ti2商务便携男女士大容量茶杯纯钛茶水分离杯w847",
                pic: "",
                oprice: "99",
                price: "79"
            },
            {
                id: "",
                name: "小米智能保温杯Ti2商务便携男女士大容量茶杯纯钛茶水分离杯w847",
                pic: "",
                oprice: "99",
                price: "79"
            },
            {
                id: "",
                name: "小米智能保温杯Ti2商务便携男女士大容量茶杯纯钛茶水分离杯w847",
                pic: "",
                oprice: "99",
                price: "79"
            },
            {
                id: "",
                name: "小米智能保温杯Ti2商务便携男女士大容量茶杯纯钛茶水分离杯w847",
                pic: "",
                oprice: "99",
                price: "79"
            }
        ]
    },
    lrEdge: {
        title: "左右边距",
        val: 10,
        min: 0
    },
    mbConfig: {
        title: "商品间距",
        val: 0,
        min: 0
    },
    id: "id1723002323011000"
}